module.exports = __webpack_public_path__ + "static/image15@2x-17a3754d7a1043571d6dcbf7f4f856e2.png";